{
  "native": {
    "language": "Español",
    "variant": "México",
    "variantHint": "tú/ustedes",
    "testPhrase": "El clima es muy agradable hoy"
  },
  "chat": {
    "topics": {
      "readyBody": "Envía un mensaje de texto o voz y recibe feedback sobre tu gramática, pronunciación y fluidez.",
      "tipBody": "Prueba el micrófono para recibir feedback sobre tu pronunciación. Habla con naturalidad — ¡los errores son parte del aprendizaje!",
      "hobbyLabel": "Tu hobby favorito"
    },
    "consent": {
      "explanation": "Para darte feedback personalizado sobre tu pronunciación y gramática, compartimos algunos datos con los siguientes servicios de IA:",
      "disclaimerText": "Sin consentimiento, las funciones con IA como el análisis de conversación y el feedback de pronunciación no estarán disponibles."
    },
    "report": {
      "successMessage": "Gracias por tu feedback. Revisaremos esta respuesta de IA."
    }
  },
  "profile": {
    "aiConsent": {
      "description": "Fluencia usa servicios de IA externos para ofrecer feedback de pronunciación y análisis gramatical.",
      "notGrantedDescription": "Las funciones con IA están deshabilitadas. Otorga consentimiento desde el Chat para habilitar el feedback de pronunciación y gramática.",
      "withdrawMessage": "¿Estás seguro de que quieres revocar el consentimiento de IA?\n\nLas funciones como feedback de pronunciación y análisis gramatical se deshabilitarán."
    }
  },
  "paywall": {
    "detailedFeedback": "Feedback detallado de pronunciación"
  },
  "featureGate": {
    "features": {
      "detailedFeedback": "Feedback detallado"
    }
  },
  "roleplay": {
    "list": {
      "title": "Simulaciones",
      "sectionYours": "Tus juegos de rol",
      "createCustom": "Crear juego de rol personalizado",
      "slotsFull": "{{cap}}/{{cap}} espacios usados",
      "slotLabel": "{{title}} — {{scenario}}",
      "templateLabel": "{{title}}",
      "loadErrorRetry": "Reintentar"
    },
    "templates": {
      "preview": {
        "title": "Vista previa",
        "sectionVocabulary": "Vocabulario",
        "sectionPhrases": "Frases clave",
        "startButton": "Comenzar este juego de rol",
        "statusNew": "Nueva",
        "statusLearning": "En curso",
        "statusMastered": "Dominada"
      }
    },
    "collections": {
      "sectionTitle": "Colecciones",
      "progress": "{{completed}}/{{total}} hechos",
      "cardLabel": "{{title}}, {{completed}} de {{total}} hechos",
      "searchPlaceholder": "Buscar juegos de rol",
      "searchClear": "Borrar búsqueda",
      "searchEmpty": "Sin coincidencias. Prueba otra palabra.",
      "emptyHint": "Aún no hay colecciones disponibles.",
      "difficultyLabel": "Niv. {{level}}",
      "filterDifficultyLabel": "Filtrar por nivel {{level}}",
      "filterCompleted": "Completados",
      "filterUncompleted": "Sin empezar"
    }
  },
  "soundMap": {
    "title": "Mapa de sonidos",
    "loading": "Cargando tu mapa de sonidos...",
    "loadError": "No se pudo cargar tu mapa de sonidos.",
    "progressLabel": "{{mastered}} de {{total}} sonidos dominados",
    "summary": {
      "mastered_one": "{{count}} dominado",
      "mastered_other": "{{count}} dominados",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "weak_one": "{{count}} débil",
      "weak_other": "{{count}} débiles",
      "untried_one": "{{count}} sin practicar",
      "untried_other": "{{count}} sin practicar"
    },
    "sections": {
      "consonants": "Consonantes",
      "vowels": "Vocales",
      "diphthongs": "Diptongos",
      "tones": "Tonos"
    },
    "states": {
      "mastered": "Dominado",
      "learning": "En progreso",
      "weak": "Débil",
      "untried": "Sin practicar"
    },
    "chip": {
      "scoreValue": "{{score}}%",
      "a11yMastered": "{{symbol}}, dominado, {{score}} por ciento",
      "a11yLearning": "{{symbol}}, en progreso, {{score}} por ciento",
      "a11yWeak": "{{symbol}}, débil, {{score}} por ciento",
      "a11yUntried": "{{symbol}}, sin practicar",
      "a11yUntriedHard": "{{symbol}}, sin practicar, suele ser difícil"
    },
    "detail": {
      "exampleWordsTitle": "Palabras de ejemplo",
      "statsAvgScore": "Puntuación promedio",
      "statsAttempts": "Intentos",
      "statsLastPracticed": "Última práctica",
      "notPracticedYet": "Todavía no has practicado este sonido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Este sonido suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar este sonido",
      "closeA11y": "Cerrar detalles del sonido"
    },
    "practiceCard": {
      "title": "Mapa de sonidos",
      "subtitle": "Sigue tu dominio de cada sonido",
      "cta": "Abre el mapa de sonidos"
    },
    "guidanceOnly": {
      "summary": "Los sonidos del inglés que más cuestan a quienes hablan español",
      "body": "Estos son los sonidos de tu inglés. Los marcados son los que suelen costar más a quienes hablan español: toca cualquiera para ver consejos y practicarlo con tu tutor."
    }
  },
  "competenceMap": {
    "title": "Mapa de competencias",
    "loading": "Cargando tu mapa de competencias...",
    "loadError": "No se pudo cargar tu mapa de competencias.",
    "progressLabel": "{{mastered}} de {{total}} competencias dominadas",
    "dueTitle": "Para repasar hoy",
    "bandEmpty": "Todavía no hay contenido de este nivel.",
    "bandCount_one": "{{count}} competencia",
    "bandCount_other": "{{count}} competencias",
    "bandLater_one": "{{count}} más adelante",
    "bandLater_other": "{{count}} más adelante",
    "summary": {
      "mastered_one": "{{count}} dominada",
      "mastered_other": "{{count}} dominadas",
      "learning_one": "{{count}} en progreso",
      "learning_other": "{{count}} en progreso",
      "struggling_one": "{{count}} con dificultades",
      "struggling_other": "{{count}} con dificultades",
      "untried_one": "{{count}} sin ver",
      "untried_other": "{{count}} sin ver",
      "upcoming_one": "{{count}} más adelante",
      "upcoming_other": "{{count}} más adelante"
    },
    "bands": {
      "A1": "A1 · Principiante",
      "A2": "A2 · Elemental",
      "B1": "B1 · Intermedio",
      "B2": "B2 · Intermedio alto",
      "C1": "C1 · Avanzado",
      "C2": "C2 · Dominio",
      "any": "En cualquier nivel"
    },
    "states": {
      "mastered": "Dominada",
      "learning": "En progreso",
      "struggling": "Con dificultades",
      "untried": "Sin ver",
      "upcoming": "Más adelante"
    },
    "chip": {
      "due": "Para repasar",
      "a11y": "{{name}}, {{state}}",
      "a11yWithHard": "{{name}}, {{state}}, suele ser difícil"
    },
    "detail": {
      "examplesTitle": "Ejemplos",
      "exampleCorrect": "✓ {{text}}",
      "exampleIncorrect": "✗ {{text}}",
      "statsProductions": "Usos correctos",
      "statsStruggles": "Errores",
      "statsSessions": "Sesiones",
      "statsLastUsed": "Última vez",
      "statsNextReview": "Próximo repaso",
      "notSeenYet": "Todavía no te hemos visto usar esto.",
      "comesLater": "Esto llega más adelante en tu recorrido.",
      "difficultyLabel": "Dificultad esperada",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "Esto suele ser difícil para hispanohablantes.",
      "tipsTitle": "Consejos",
      "practiceButton": "Practicar esto",
      "closeA11y": "Cerrar detalles de la competencia"
    },
    "practiceCard": {
      "title": "Mapa de competencias",
      "subtitle": "Sigue tu dominio de la gramática",
      "cta": "Abre el mapa de competencias"
    }
  },
  "vocabulary": {
    "title": "Tu vocabulario",
    "hubCard": {
      "title": "Tu vocabulario",
      "subtitle": "Palabras y expresiones que practicas",
      "counts": "{{mastered}} dominadas · {{due}} para repasar"
    },
    "counts": {
      "new": "Nuevas",
      "learning": "Aprendiendo",
      "mastered": "Dominadas"
    },
    "due": {
      "title": "Para repasar",
      "empty": "No tienes nada pendiente de repaso. ¡Sigue así!",
      "more": "y {{overflow}} más para repasar"
    },
    "list": {
      "learning": "Aprendiendo",
      "mastered": "Dominadas",
      "empty": "Todavía no hay nada aquí. Prueba una simulación para empezar."
    },
    "error": {
      "retry": "Reintentar"
    }
  },
  "errors": {
    "api": {
      "ROLEPLAY_TEMPLATE_NOT_FOUND": "Esta plantilla ya no está disponible."
    }
  },
  "vocabSets": {
    "title": "Conjuntos de palabras",
    "drillTitle": "Práctica",
    "loading": "Cargando…",
    "loadError": "No pudimos cargar los conjuntos.",
    "intro": "Grupos de palabras para practicar directamente. Escribe la palabra en inglés: solo cuenta si la produces tú.",
    "countLabel": "{{done}} de {{total}} dominadas",
    "inputPlaceholder": "Escribe la palabra en inglés",
    "check": "Comprobar",
    "reveal": "Mostrar la respuesta",
    "next": "Siguiente",
    "empty": "Este conjunto todavía no tiene palabras.",
    "markError": "No pudimos guardar tu respuesta. Inténtalo de nuevo.",
    "speak": "Decirlo en voz alta",
    "pronunciationScore": "Pronunciación: {{score}}/100",
    "notHeard": "No te escuchamos bien. Inténtalo otra vez."
  }
}
